import { MachineLearningModel } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Настройки AI (БО-30): режимы и каналы клиник, версии моделей и промптов, раскатка на долю клиник и откат.
 * Чтение — DODOC_ADMIN, DODOC_QA, DODOC_SUPPORT; раскатка — DODOC_ADMIN и DODOC_QA; режим клиники — DODOC_ADMIN.
 */
export const section = defineSection({
  id: 'backoffice.ai',
  area: 'backoffice',
  path: 'ai',
  roles: ['DODOC_ADMIN', 'DODOC_QA', 'DODOC_SUPPORT'],
  icon: MachineLearningModel,
  titleKey: 'boAi:title',
  namespaces: ['portal', 'backoffice'],
  navGroup: 'quality',
  order: 300,
  load: () => import('./AiSettingsPage'),
});
